import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import type { Meta } from '../../App.types'
import useGetTopContentHeight from '../../hooks/useGetTopContentHeight'

import { VenueMatches, VenueOverview, VenueTeam, VenueVouchers } from './Content'
import { DesktopSidebar } from './Sidebar'
import Routes from './VenueProfile.routes'
import type { Venue } from './VenueProfile.types'
import VenueProfileContentContainer from './VenueProfileContentContainer'

interface Props {
  venue: Venue
  meta: Meta
}

const VenueProfileContent = ({ venue, meta }: Props) => {
  const { url, path } = useRouteMatch()
  const { DESKTOP_TOP_CONTENT_HEIGHT: TOP_CONTENT_HEIGHT } = useGetTopContentHeight(['NAVIGATION_BAR', 'PAGE_TITLE'])

  return (
    <Switch>
      <Route exact path={path}>
        <VenueProfileContentContainer variant="with-sidebar">
          <VenueOverview venue={venue} meta={meta} headerOffset={TOP_CONTENT_HEIGHT} />
          <DesktopSidebar venue={venue} headerOffset={TOP_CONTENT_HEIGHT} />
        </VenueProfileContentContainer>
      </Route>
      <Route path={`${url}${Routes.TEAM}`}>
        <VenueProfileContentContainer variant="with-sidebar">
          <VenueTeam venue={venue} meta={meta} />
          <DesktopSidebar venue={venue} headerOffset={TOP_CONTENT_HEIGHT} />
        </VenueProfileContentContainer>
      </Route>
      <Route path={`${url}${Routes.MATCHES}`}>
        <Stack gap={4} sx={{ width: '100%' }}>
          <VenueMatches venue={venue} meta={meta} />
        </Stack>
      </Route>
      <Route path={`${url}${Routes.VOUCHERS}`}>
        <VenueProfileContentContainer variant="with-sidebar">
          <Stack>
            <VenueVouchers venue={venue} meta={meta} />
          </Stack>
        </VenueProfileContentContainer>
      </Route>
    </Switch>
  )
}

export default VenueProfileContent
